<template>
	<div ref="content" class="content background2">
		<div ref="search">
			<SearchList ref="searchContent" :searchList="searchList"></SearchList>
		</div>
		<div ref="btnList">
			<BtnList ref="btn" :btnList="btnList"></BtnList>
		</div>
		<div ref="tableList" class="list" :style="{ 'padding-top': paddingTop }">
			<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
				@parentMethod="getInfo"></List>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
		<el-dialog title="绑定坐标" :center="true" :visible.sync="dialog" :append-to-body="true"
			:close-on-click-modal="false" width="700px" custom-class="dialog-style">
			<div class="dialog-content">
				<baidu-map ref="baiduMap" class="map" :scroll-wheel-zoom="true" :center="center" :zoom="zoom"
					@ready="handler" @click="clickMap">
					<bm-local-search :location="keyword1" :keyword="keyword2" :panel="false" :selectFirstResult="true"
						:auto-viewport="true" @searchcomplete="searchcomplete"></bm-local-search>
					<bm-marker :position="mappoint" :massClear="false" :dragging="true"></bm-marker>
				</baidu-map>
			</div>
			<el-form :model="keyword2" label-width="80px" style="margin-top: 10px">
				<el-form-item label="地图搜索">
					<el-input v-model="keyword2"></el-input>
				</el-form-item>
			</el-form>
			<el-form :inline="true" label-width="80px" :model="mappoint">
				<el-form-item label="经度">
					<el-input v-model="mappoint.lng"></el-input>
				</el-form-item>
				<el-form-item label="纬度">
					<el-input v-model="mappoint.lat"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialog = false">取 消</el-button>
				<el-button type="primary" @click="bindingMap()">绑 订</el-button>
			</span>
		</el-dialog>
		<el-dialog title="设备列表" class="dialogequipment" :center="true" :visible.sync="dialogequipment"
			:append-to-body="true" :close-on-click-modal="false" width="1200px" custom-class="dialog-style">
			<div style="height: 500px;">
				<List ref="equipmentlist" :tableData="equipmenttableData" :tableList="equipmenttableList"
					:pageSize="equipmentpageSize" :pageNo="equipmentpageNo"></List>
			</div>
			<div ref="page" class="page">
				<Page ref="equipmenpageModel" :total="equipmentpageCount" :display="equipmentpageSize" :pagegroup="3"
					:currentspage="1" @parentMethod="Devicesearch"></Page>
			</div>
		</el-dialog>
		<el-dialog title="安装位置" class="dialogaddress" :center="true" :visible.sync="dialogaddress"
			:append-to-body="true" :close-on-click-modal="false" width="1200px" top="5%" custom-class="dialog-style">
			<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false"
				:http-request="upload">
				<div style="background-color: #2CBA85; width: 100px; height: 30px;
				text-align: center; line-height: 30px; margin-left: 7px; margin-bottom: 5px;
				color: #fff;border: 0;border-radius: 15px;font-size: 16px;">图片上传</div>
			</el-upload>
			<div v-if="imgList.length == 0" style="height: 550px;"></div>
			<div style="display: flex;" v-for="item in imgList">
				<img style="margin-bottom: 5px;" :src="$store.getters.getPostUrl + '/customer/download?img=' + item"
					height="600" width="100%" />
				<i class="el-icon-error" style="color: red; font-size: 20px;margin-left: 3px;"
					@click="delImg(item)"></i>
			</div>
			<!-- <img id="cust_img2" name="cust_img2" :src="cust_img2" height="600" width="100%" :style="cust_img2display" />
			<img id="cust_img3" name="cust_img3" :src="cust_img3" height="600" width="100%" :style="cust_img3display" />
			<img id="cust_img4" name="cust_img4" :src="cust_img4" height="600" width="100%" :style="cust_img4display" />
			<img id="cust_img5" name="cust_img5" :src="cust_img5" height="600" width="100%" :style="cust_img5display" />
			<img id="cust_img6" name="cust_img6" :src="cust_img6" height="600" width="100%" :style="cust_img6display" />
			<img id="cust_img7" name="cust_img7" :src="cust_img7" height="600" width="100%" :style="cust_img7display" />
			<img id="cust_img8" name="cust_img8" :src="cust_img8" height="600" width="100%" :style="cust_img8display" />
			<img id="cust_img9" name="cust_img9" :src="cust_img9" height="600" width="100%" :style="cust_img9display" />
			<img id="cust_img10" name="cust_img10" :src="cust_img10" height="600" width="100%"
				:style="cust_img10display" />
			<img id="cust_img11" name="cust_img11" :src="cust_img11" height="600" width="100%"
				:style="cust_img11display" />
			<img id="cust_img12" name="cust_img12" :src="cust_img12" height="600" width="100%"
				:style="cust_img12display" />
			<img id="cust_img13" name="cust_img13" :src="cust_img13" height="600" width="100%"
				:style="cust_img13display" /> -->
		</el-dialog>
		<el-dialog title="探测器监视" class="dialogequipment" :center="true" :visible.sync="dialogtcqjs"
			:append-to-body="true" :close-on-click-modal="false" width="1200px" custom-class="dialog-style">
			<template v-for="item in deviceMList.length">
				<div :id="'eqmonitor1' + item" name="eqmonitor1"></div>
				<div :id="'eqmonitor2' + item" name="eqmonitor2" style="margin-top: 10px;"></div>
				<div :id="'eqmonitor3' + item" name="eqmonitor3" style="margin-top: 10px;"></div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css";
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	import CommonJs from "@/assets/js/common/common.js";

	export default {
		name: "list",
		components: {
			List,
			SearchList,
			BtnList,
			Page,
		},
		data() {
			const $this = this;
			return {
				dialog: false,
				dialogequipment: false,
				dialogaddress: false,
				dialogtcqjs: false,
				dialogTime: 0,
				cuid: '',
				cust_img: "",
				cust_img2: "",
				cust_img2display: "display:none",
				cust_img3: "",
				cust_img3display: "display:none",
				cust_img4: "",
				cust_img4display: "display:none",
				cust_img5: "",
				cust_img5display: "display:none",
				cust_img6: "",
				cust_img6display: "display:none",
				cust_img7: "",
				cust_img7display: "display:none",
				cust_img8: "",
				cust_img8display: "display:none",
				cust_img9: "",
				cust_img9display: "display:none",
				cust_img10: "",
				cust_img10display: "display:none",
				cust_img11: "",
				cust_img11display: "display:none",
				cust_img12: "",
				cust_img12display: "display:none",
				cust_img13: "",
				cust_img13display: "display:none",
				center: {
					lng: 0,
					lat: 0,
				},
				mappoint: {
					lng: 0,
					lat: 0,
				},
				savepoint: {
					lng: 0,
					lat: 0,
				},
				zoom: 3,
				keyword1: "",
				keyword2: "",
				paddingTop: 0,
				addCustomerUserId: "",
				customerId: "",
				customerName: "",
				searchList: [{
						searchLabel: "客户名称",
						searchValue: "",
						searchType: 0,
						searchWidth: "25%",
						searchBr: false,
						column: "customerName",
					},
					{
						searchLabel: "客户类型",
						searchValue: "",
						searchType: 1,
						searchTermList: [],
						searchWidth: "25%",
						searchBr: false,
						column: "customerType",
					},
					{
						searchLabel: "所在区域",
						searchValue: "",
						searchType: 0,
						searchWidth: "25%",
						searchBr: false,
						column: "abbreviation",
					},
					{
						searchLabel: "联系人",
						searchValue: "",
						searchType: 0,
						searchWidth: "25%",
						searchBr: false,
						column: "contact",
					},
				],
				btnList: [],
				tableList: [{
						column: "customerName",
						title: "客户名称",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "abbreviation",
						title: "所在区域",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},

					{
						column: "customerType",
						title: "客户类型",
						headerAlign: "center",
						align: "center",
						termList: [],
						width: "20%",
					},
					{
						column: "addressDetail",
						title: "客户地址",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "contact",
						title: "联系人",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "contactPhone",
						title: "联系人电话",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "anzhuangUnit",
						title: "安装单位",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
					{
						column: "astrict",
						title: "微信用户限制",
						headerAlign: "center",
						align: "center",
						width: "20%",
					},
				],
				map: "",
				customerTypeList: [],
				tableData: [],
				tableInfo: {},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
				equipmentpageCount: 0,
				equipmentpageSize: 10,
				equipmentpageNo: 1,
				equipmenttableData: [],
				equipmentList: [],
				equipmenttableList: [{
					column: 'code',
					title: '设备编号',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'name',
					title: '设备名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'deviceType',
					title: '设备类型',
					headerAlign: 'center',
					align: 'center',
					termList: [],
					width: '20%'
				}, {
					column: 'deviceAddress',
					title: '安装位置',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'probeheadtotal',
					title: '探头数量',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'warranty',
					title: '保修时长（天）',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'productionUnit',
					title: '生产单位',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'bindtime',
					title: '安装日期',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'notes',
					title: '监控燃气种类',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}],
				imgList: [],
				id: '',
				deviceMList: [],
				userCustomerList: []
			};
		},
		methods: {
			upload(file1) {
				var formData = new FormData();
				formData.append('file', file1.file);
				CommonJs.upload(formData, this.id).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.search({
							pageNo: this.pageNo,
							pageSize: this.pageSize,
						});
						this.imgList = [];
						if (data.data != null && data.data != '') {
							this.imgList = data.data.split(',');
						}
						this.utils.tipsAlert("上传成功");
					} else {
						utils.tipsAlert(data.message);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			delImg(img) {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					CommonJs.delImg(img).then((response) => {
						const data = response.data;
						if (data.code == 1) {
							this.search({
								pageNo: this.pageNo,
								pageSize: this.pageSize,
							});
							this.utils.tipsAlert("删除成功");
							this.imgList = [];
							if (data.data != null && data.data != '') {
								this.imgList = data.data.split(',');
							}
						} else {
							utils.tipsAlert(data.message);
						}
					}).catch((response) => {
						console.log(response)
					})
				}).catch(() => {

				});
			},
			Devicesearch(param) {
				var newParam = Object.assign(param, {
					customerName: this.tableInfo.customerName
				});
				this.getDeviceList(newParam);
			},
			getDeviceList(param) {
				User.getDeviceList(param).then((response) => {
					const data = response.data;
					this.equipmentpageCount = data.data.total;
					this.equipmentpageNo = data.data.current;
					this.$refs['equipmenpageModel'].setCurrent(this.equipmentpageNo);
					this.equipmenttableData = data.data.records;
				}).catch((response) => {
					console.log(response)
				})
			},
			searchcomplete(e) {
				this.$nextTick(() => {
					if (e && e.Hr) {
						var info = this.tableInfo;
						if (info.lng == null || info.lng == "" || info.lng == undefined) {
							this.mappoint = e.Hr[0].point; //这里获取了检索的位置并跳转
						}
						this.map.clearOverlays(); //这里进行清除所有的点
					}
				});
			},
			handler({
				BMap,
				map
			}) {
				var info = this.tableInfo;
				if (info.lng != null && info.lng != "" && info.lng != undefined) {
					this.center.lng = info.lng;
					this.center.lat = info.lat;
					this.mappoint.lng = info.lng;
					this.mappoint.lat = info.lat;
				} else {
					this.center.lng = 116.404;
					this.center.lat = 39.915;
					this.mappoint.lng = 116.404;
					this.mappoint.lat = 39.915;
				}
				this.zoom = 15;
				this.map = map;
			},
			bindingMap() {
				let info = {};
				info.lng = this.mappoint.lng;
				info.lat = this.mappoint.lat;
				info.id = this.tableInfo.id;
				User.UpdateCustomer(info)
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							this.utils.tipsAlert("绑定成功");
							this.search({
								pageNo: this.pageNo,
								pageSize: this.pageSize,
							});
							this.dialog = false;
							tip();
						} else {
							$this.utils.tipsAlert(data.message);
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			clickMap(e) {
				this.mappoint.lng = e.point.lng;
				this.mappoint.lat = e.point.lat;
			},
			queryArea() {},
			async getCustomerTypeList() {
				await CommonJs.getDict("客户类型")
					.then((response) => {
						const data = response.data;

						if (data.code == 1) {
							let list = [];
							data.data.forEach(function(item, index) {
								var param = {};
								param.id = item.rank;
								param.name = item.value;
								list.push(param);
							});
							this.tableList[2].termList = list;
							this.searchList[1].searchTermList = list;
							this.btnList[0].columnList[2].columnTermList = list;
							this.btnList[1].columnList[2].columnTermList = list;
							this.customerTypeList = list;
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			getCustomer(param) {
				this.utils.startLoading();
				this.tableData = [];
				if (this.userCustomerList.roleId == '1382271066769252353') {
					param.pageSize = 9999;
				}
				User.getCustomerPage(param)
					.then((response) => {
						this.utils.endLoading();
						if (this.userCustomerList.roleId == '1382271066769252353') {
							let param = {};
							let customerId = '';
							param.userId = this.userCustomerList.userId;
							User.getChooseCustomerList(param)
							  .then((response1) => {
							    const data1 = response1.data;
								console.log(data1.data[0]);
							    if (data1.code == 1) {
									customerId = data1.data[0].customerId;
									const data = response.data.data.records;
									data.forEach((item, index) => {
										if (item.id == customerId) {
											this.tableData.push(item);
										}
									});
									this.pageCount = this.tableData.length;
									this.pageNo = data.data.current;
									this.$refs["pageModel"].setCurrent(this.pageNo);
								}
							})
							.catch((response) => {
								console.log(response);
							});	
						} else {
							const data = response.data;
							this.pageCount = data.data.total;
							this.pageNo = data.data.current;
							this.$refs["pageModel"].setCurrent(this.pageNo);
							this.tableData = data.data.records;
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			getExport(param) { //导出
				let $this = this;
				// var param = this.$refs.searchContent.getSearchParam();
				User.getCustomerList(param)
					.then((response) => {
						const data = response.data.data;
						// console.log(data);
						let list = [];
						data.forEach((item, index) => {
							var param = {};
							param.customerName = item.customerName == null ? " " : item.customerName;
							param.abbreviation = item.abbreviation == null ? " " : item.abbreviation;
							param.customerType = item.customerType == null ? " " : item.customerType;
							param.address = item.address == null ? " " : item.address;
							param.contact = item.contact == null ? " " : item.contact;
							param.contactPhone = item.contactPhone == null ? " " : item.contactPhone;
							this.customerTypeList.forEach((item1) => {
								if (item1.id === item.customerType) {
									param.customerType = item1.name;
								}
							});
							list.push(param);
						});
						this.btnList[2].sheet[0].table = list;
						// this.btnList[2].sheet[1].table = list;
					})
					.catch((response) => {
						console.log(response);
					});
				// User.getBaseDeviceList(param)
				// 	.then((response) => {
				// 		const data = response.data.data;
				// 		// console.log(data);
				// 		let list = [];
				// 		data.forEach((item, index) => {
				// 			var param = {};
				// 			if (item.deviceType != null) {
				// 				for (var i = 0; i < this.equipmentList.length; i++) {
				// 					if (item.deviceType == this.equipmentList[i].id) {
				// 						param.deviceType = this.equipmentList[i].name;
				// 					}
				// 				}
				// 			} else {
				// 				param.deviceType = " ";
				// 			}
				// 			param.customerName = item.customerName == null ? " " : item.customerName;
				// 			param.code = item.code == null ? " " : item.code;
				// 			param.name = item.name == null ? " " : item.name;
				// 			param.deviceAddress = item.deviceAddress == null ? " " : item.deviceAddress;
				// 			param.warranty = item.warranty == null ? " " : item.warranty;
				// 			param.productionDate = item.productionDate == null ? " " : item.productionDate;
				// 			param.price = item.price == null ? " " : item.price;
				// 			param.notes = item.notes == null ? " " : item.notes;
				// 			list.push(param);
				// 		});
				// 		this.btnList[2].sheet[1].table = list;
				// 		console.log(list)
				// 	})
				// 	.catch((response) => {
				// 		console.log(response);
				// 	});
			},
			search(param) {
				var dataParam = this.$refs.searchContent.getSearchParam();
				var newParam = Object.assign(param, dataParam);
				this.getCustomer(newParam);
				this.getExport(dataParam);
			},
			getWindowHeight() {
				let height = "";
				height =
					this.$refs.tableList.clientHeight -
					(this.$refs.search.clientHeight +
						this.$refs.btnList.clientHeight +
						20) -
					60;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize,
				});
			},
			getInfo(info) {
				this.tableInfo = info;
				this.cuid = info.id;
				clearTimeout(this.dialogTime);
				this.geteqMonitor1();
				this.dialogTime = null;
			},
			getTime(time) {
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
				1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let Hours = zeroTime.getHours() < 10 ? '0' + zeroTime.getHours() : zeroTime.getHours()
				let Minutes = zeroTime.getMinutes() < 10 ? '0' + zeroTime.getMinutes() : zeroTime.getMinutes()
				let Seconds = zeroTime.getSeconds() < 10 ? '0' + zeroTime.getSeconds() : zeroTime.getSeconds()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates + ' ' + Hours + ':' + Minutes + ':' +
				Seconds;
				return now;
			},
			geteqMonitor1() {
				User.geteqMonitor(this.cuid).then((response) => {
					this.deviceMList = response.data.data;
				}).catch((response) => {
					console.log(response)
				})
			},
			geteqMonitor() {
				// document.getElementById("eqmonitor").innerHTML = '';
				// document.getElementById("eqmonitor2").innerHTML = '';
				// document.getElementById("eqmonitor3").innerHTML = '';
				//const $this = this;
				//alert($this.dialogTime + '=====>>>>>' + customerid);
				User.geteqMonitor(this.cuid).then((response) => {
					//console.log(response.data.code);
					this.deviceMList = response.data.data;
					let deviceMesList = response.data.data;
					//alert(deviceMesList.data);
					var deviceList = ""; //主控器报警信息
					var tcqList = ""; //探测器报警信息
					var ldqList = ""; //联动器报警信息
					let nowtime = new Date();
					//设备循环
					for (var i = 0; i < deviceMesList.length; i++) {
						//alert(deviceMesList[i].probeHeadTotal);
						//alert(deviceMesList[i].points.length);
						if (deviceMesList[i]) {
							let pointListST = '';
							let pointList = '';
							let pointListLD = '';
							let ldCount = 1;
							//探头循环
							for (var q = 0; q < deviceMesList[i].points.length; q++) {
								if (deviceMesList[i].points[q] != null &&
									deviceMesList[i].points[q] != '' &&
									deviceMesList[i].points[q] != undefined) {
									let displayName = deviceMesList[i].points[q].displayName;
									let address = '';
									let status = '';
									let valueTxt = '';
									let alarmTxt = '正常';
									let backgroundcolor = '';

									if (deviceMesList[i].points[q].address != null &&
										deviceMesList[i].points[q].address != '' &&
										deviceMesList[i].points[q].address != undefined) {
										address = deviceMesList[i].points[q].address;
									}

									if (deviceMesList[i].points[q].pointId.startsWith("ST")) {
										//主控器
										if (deviceMesList[i].points[q].alarm == 1) {
											alarmTxt = '报警';
										}
										if (deviceMesList[i].points[q].value == 0) {
											valueTxt = ' '
										} else {
											//valueTxt = deviceMesList[i].points[q].value.toFixed(0)+' %'
											valueTxt = ' '
										}

										pointListST += '<tr>' +
											'<td style="text-align: center;">' + displayName + '</td>' +
											//'<td style="text-align: center;">' + valueTxt + '</td>' +
											'<td class="alarm" style="text-align: center;" >' + alarmTxt +
											'</td>' +
											'<td class="address" style="text-align: center;">' + address +
											'</td>' +
											'</tr>';

									} else if (deviceMesList[i].points[q].pointId.startsWith("ND") &&
										deviceMesList[i].points[q].pointId.split('_')[1] <= deviceMesList[i]
										.probeHeadTotal
									) {
										displayName = displayName.replace('浓度值', '');
										//探测器
										if (deviceMesList[i].points[q + 1].alarm == 1) {
											alarmTxt = '报警';
											backgroundcolor = 'background-color:red;color:white;';
										}
										if (deviceMesList[i].points[q + 1].value == 3 || deviceMesList[i].points[q + 1].value == 6) {
											alarmTxt = '故障';
											backgroundcolor = 'background-color:red;color:white;';
										}
										if (deviceMesList[i].points[q].value == 0) {
											valueTxt = ' ';
										} else {
											//valueTxt = deviceMesList[i].points[q].value.toFixed(0)+' %'
											valueTxt = ' ';
										}
										var pointsValue = deviceMesList[i].points[q].value
											.toFixed(0);
										if (deviceMesList[i].points[q].value.toFixed(0) > 100) {
											pointsValue = "";
										}
										valueTxt = pointsValue + ' %';
										q = q + 1;

										pointList += '<tr style="' + backgroundcolor + '">' +
											'<td style="text-align: center;">' + displayName + '</td>' +
											'<td style="text-align: center;">' + valueTxt + '</td>' +
											'<td class="alarm" style="text-align: center;">' + alarmTxt + '</td>' +
											'<td class="address" style="text-align: center;">' + address +
											'</td>' +
											'</tr>';
									} else if (deviceMesList[i].points[q].pointId.startsWith("LD")) {
										alarmTxt = '通讯故障';
										if (ldCount % 2 != 0) {
											address = '燃气紧急切断阀';
										} else {
											address = '事故风机';
										}
										//displayName = displayName.replace('浓度值', '');
										//联动器
										if (deviceMesList[i].points[q].value == 0) {
											if (ldCount % 2 != 0) {
												address = '燃气紧急切断阀';
												alarmTxt = '开启';
											} else {
												address = '事故风机';
												alarmTxt = '关闭';
											}
										} else if (deviceMesList[i].points[q].value == 1) {
											if (ldCount % 2 != 0) {
												address = '燃气紧急切断阀';
												alarmTxt = '关闭';
											} else {
												address = '事故风机';
												alarmTxt = '开启';
											}
										}
										ldCount ++;
										pointListLD += '<tr">' +
											'<td style="text-align: center;">' + displayName + '</td>' +
											'<td class="alarm" style="text-align: center;">' + alarmTxt + '</td>' +
											'<td class="address" style="text-align: center;">' + address +
											'</td>' +
											'</tr>';
									}

								}
							}
							deviceList =
								'<div class="tableBox" style="margin-top: 20px;>' +
								'<p class="tableTitle"><span>数据时间：' + this.getTime(deviceMesList[i].timeMillis) +
								'</span>' +
								'&nbsp;&nbsp;&nbsp;&nbsp;<span>主控器编号：' + deviceMesList[i].deviceId + '</span>' +
								'&nbsp;&nbsp;&nbsp;&nbsp;<span>探测器数量：' + deviceMesList[i].probeHeadTotal +
								'</span>' +
								'&nbsp;&nbsp;&nbsp;&nbsp;<span>信号强度：强</span>' +
								'&nbsp;&nbsp;&nbsp;&nbsp;<span>刷新时间：' + this.getTime(nowtime) + '</span></p>\n' +
								'        <table border="1" cellspacing="0" style="width:100%;">\n' +
								'            <thead>\n' +
								'            <tr style="background-color:gray;color:white;">\n' +
								'                <td style="width: 46%;text-align: center;">主控器</td>\n' +
								//'                <td style="width: 12%;text-align: center;"> </td>\n' +
								'                <td style="width: 20%;text-align: center;">状态</td>\n' +
								'   		     <td style="text-align: center;">位置</td>\n' +
								'            </tr>\n' +
								'            </thead>\n' +
								'            <tbody>\n' + pointListST +
								'            </tbody>\n' +
								'        </table></div>';

							tcqList =
								'<div class="tableBox" >' +
								'        <table border="1" cellspacing="0" style="width:100%;">\n' +
								'            <thead>\n' +
								'            <tr style="background-color:gray;color:white;">\n' +
								'                <td style="width: 26%;text-align: center;">探测器</td>\n' +
								'                <td style="width: 20%;text-align: center;">浓度</td>\n' +
								'                <td style="width: 20%;text-align: center;">状态</td>\n' +
								'   		     <td style="text-align: center;">位置</td>\n' +
								'            </tr>\n' +
								'            </thead>\n' +
								'            <tbody>\n' + pointList +
								'            </tbody>\n' +
								'        </table></div>';

							ldqList =
								'<div class="tableBox">' +
								'        <table border="1" cellspacing="0" style="width:100%;">\n' +
								'            <thead>\n' +
								'            <tr style="background-color:gray;color:white;">\n' +
								'                <td style="width: 46%;text-align: center;">联动器</td>\n' +
								'                <td style="width: 20%;text-align: center;">状态</td>\n' +
								'   		     <td style="text-align: center;">关联设备</td>\n' +
								'            </tr>\n' +
								'            </thead>\n' +
								'            <tbody>\n' + pointListLD +
								'            </tbody>\n' +
								'        </table></div>';
							document.getElementById("eqmonitor1" + (i + 1)).innerHTML = deviceList;
							document.getElementById("eqmonitor2" + (i + 1)).innerHTML = tcqList;
							document.getElementById("eqmonitor3" + (i + 1)).innerHTML = ldqList;
						}
					}
					//alert(deviceList);
					//eqmonitor
				}).catch((response) => {
					console.log(response)
				})
			}
		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;
			const $this = this;
			if (this.menuList.indexOf("CD_651") != -1) {
				this.btnList.push({
					btnLabel: "新增",
					btnType: 1,
					btnPosition: "left",
					title: "新增",
					columnList: [{
							columnLabel: "客户名称",
							value: "",
							column: "customerName",
							columnType: 0,
							placeholder: "请输入客户名称",
						},
						{
							columnLabel: "所在区域",
							value: "",
							column: "abbreviation",
							columnType: 0,
							placeholder: "请输入所在区域",
						},
						{
							columnLabel: "客户类型",
							value: "",
							column: "customerType",
							columnTermList: [],
							columnType: 1,
							placeholder: "请输入客户类型",
						},
						{
							columnLabel: "联系人",
							value: "",
							column: "contact",
							columnType: 0,
							placeholder: "请输入联系人",
						},
						{
							columnLabel: "联系人电话",
							value: "",
							column: "contactPhone",
							columnType: 0,
							placeholder: "请输入联系人电话",
						},
						{
							columnLabel: "办公电话",
							value: "",
							column: "officePhone",
							columnType: 0,
							placeholder: "请输入办公电话",
						},
						{
							columnLabel: "办公传真",
							value: "",
							column: "officeFax",
							columnType: 0,
							placeholder: "请输入办公传真",
						},
						{
							columnLabel: "办公邮件",
							value: "",
							column: "officeMail",
							columnType: 0,
							placeholder: "请输入办公邮件",
						},
						{
							columnLabel: "省",
							value: "",
							column: "province",
							columnType: 6,
							placeholder: "请输入地址",
							columnTermList: [],
							areaFun: function(area) {
								let info = {
									level: 1,
									areaCode: area,
								};
								User.getAdressList(info)
									.then((response) => {
										const data = response.data;
										$this.btnList[0].columnList[9].value = "";
										$this.btnList[0].columnList[10].value = "";
										$this.btnList[0].columnList[11].value = "";
										$this.btnList[0].columnList[12].value = "";
										$this.btnList[0].columnList[9].columnTermList = data.data;
									})
									.catch((response) => {});
							},
						},
						{
							columnLabel: "市",
							value: "",
							column: "city",
							columnType: 6,
							columnTermList: [],
							areaFun: function(area) {
								let info = {
									level: 2,
									areaCode: area,
								};
								User.getAdressList(info)
									.then((response) => {
										const data = response.data;
										$this.btnList[0].columnList[10].value = "";
										$this.btnList[0].columnList[11].value = "";
										$this.btnList[0].columnList[12].value = "";
										$this.btnList[0].columnList[10].columnTermList = data.data;
									})
									.catch((response) => {});
							},
							placeholder: "请输入地址",
						},
						{
							columnLabel: "区",
							value: "",
							column: "district",
							columnTermList: [],
							columnType: 6,
							areaFun: function(area) {
								let info = {
									level: 3,
									areaCode: area,
								};
								User.getAdressList(info)
									.then((response) => {
										const data = response.data;
										$this.btnList[0].columnList[11].value = "";
										$this.btnList[0].columnList[12].value = "";
										$this.btnList[0].columnList[11].columnTermList = data.data;
									})
									.catch((response) => {});
							},
							placeholder: "请输入地址",
						},
						{
							columnLabel: "街道",
							value: "",
							column: "town",
							columnTermList: [],
							columnType: 6,
							areaFun: function(area) {
								$this.btnList[0].columnList[12].value = "";
							},
							placeholder: "请输入地址",
						},
						{
							columnLabel: "详细地址",
							value: "",
							column: "address",
							columnType: 0,
							placeholder: "请输入地址",
						},
						{
							columnLabel: "邮政编码",
							value: "",
							column: "postcode",
							columnType: 0,
							placeholder: "请输入邮政编码",
						},
						{
							columnLabel: "收款账户",
							value: "",
							column: "collectionAccount",
							columnType: 0,
							placeholder: "请输入收款账户",
						},
						{
							columnLabel: "开户银行",
							value: "",
							column: "openAccountBank",
							columnType: 0,
							placeholder: "请输入开户银行",
						},
						{
							columnLabel: "税号",
							value: "",
							column: "taxNumber",
							columnType: 0,
							placeholder: "请输入税号",
						},
						{
							columnLabel: "安装单位",
							value: "上海毅知实业股份有限公司",
							column: "anzhuangUnit",
							columnType: 0,
							placeholder: "请输入安装单位",
						},
						{
							columnLabel: "微信用户限制",
							value: "5",
							column: "astrict",
							columnType: 0,
							placeholder: "请输入0~10之间的数字",
						},
					],
					btnClick: function(tip) {
						tip();
						$this.btnList[0].columnList.forEach(function(item, index) {
							if (item.column != "astrict") {
								item.value = "";
							}
						});
						let info = {
							level: 0,
						};
						User.getAdressList(info)
							.then((response) => {
								const data = response.data;
								$this.btnList[0].columnList[8].columnTermList = data.data;
							})
							.catch((response) => {});
					},
					btnFun: function(tip, info) {
						info.city = info.city.toString();
						info.district = info.district.toString();
						info.province = info.province.toString();
						info.town = info.town.toString();
						if (info.customerName == "") {
							$this.utils.tipsAlert("请输入客户名称");
							return;
						}
						if (info.abbreviation == "") {
							$this.utils.tipsAlert("请输入所在区域");
							return;
						}
						if (info.customerType === "") {
							$this.utils.tipsAlert("请输入客户类型");
							return;
						}
						if (info.contact == "") {
							$this.utils.tipsAlert("请输入联系人");
							return;
						}
						if (info.province == "") {
							$this.utils.tipsAlert("请输入地址省");
							return;
						}
						if (info.city == "") {
							$this.utils.tipsAlert("请输入地址市");
							return;
						}
						if (info.district == "") {
							$this.utils.tipsAlert("请输入地址区");
							return;
						}
						if (info.town == "") {
							$this.utils.tipsAlert("请输入地址街道");
							return;
						}
						if (info.address == "") {
							$this.utils.tipsAlert("请输入详细地址");
							return;
						}
						if (!(parseInt(info.astrict) >= 0 && parseInt(info.astrict) <= 10)) {
							$this.utils.tipsAlert("0~10之间的数");
							return;
						}
						User.AddCustomer(info)
							.then((response) => {
								const data = response.data;
								if (data.code == 1) {
									$this.utils.saveAlert();
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize,
									});
									$this.btnList[0].columnList.forEach(function(item, index) {
										item.value = "";
									});
									tip();
								} else {
									$this.utils.tipsAlert(data.message);
								}
							})
							.catch((response) => {});
					},
				});
			}
			if (this.menuList.indexOf("CD_652") != -1) {
				this.btnList.push({
					btnLabel: "编辑",
					btnType: 4,
					btnPosition: "left",
					title: "编辑",
					columnList: [{
							columnLabel: "客户名称",
							value: "",
							column: "customerName",
							columnType: 0,
							placeholder: "请输入客户名称",
						},
						{
							columnLabel: "所在区域",
							value: "",
							column: "abbreviation",
							columnType: 0,
							placeholder: "请输入所在区域",
						},
						{
							columnLabel: "客户类型",
							value: "",
							column: "customerType",
							columnTermList: [],
							columnType: 1,
							placeholder: "请输入客户类型",
						},
						{
							columnLabel: "联系人",
							value: "",
							column: "contact",
							columnType: 0,
							placeholder: "请输入联系人",
						},
						{
							columnLabel: "联系人电话",
							value: "",
							column: "contactPhone",
							columnType: 0,
							placeholder: "请输入联系人电话",
						},
						{
							columnLabel: "办公电话",
							value: "",
							column: "officePhone",
							columnType: 0,
							placeholder: "请输入办公电话",
						},
						{
							columnLabel: "办公传真",
							value: "",
							column: "officeFax",
							columnType: 0,
							placeholder: "请输入办公传真",
						},
						{
							columnLabel: "办公邮件",
							value: "",
							column: "officeMail",
							columnType: 0,
							placeholder: "请输入办公邮件",
						},
						{
							columnLabel: "省",
							value: "",
							column: "province",
							columnType: 6,
							placeholder: "请输入地址",
							columnTermList: [],
							areaFun: function(area) {
								let info = {
									level: 1,
									areaCode: area,
								};
								User.getAdressList(info)
									.then((response) => {
										const data = response.data;
										$this.btnList[1].columnList[9].value = "";
										$this.btnList[1].columnList[10].value = "";
										$this.btnList[1].columnList[11].value = "";
										$this.btnList[1].columnList[12].value = "";
										$this.btnList[1].columnList[9].columnTermList = data.data;
									})
									.catch((response) => {});
							},
						},
						{
							columnLabel: "市",
							value: "",
							column: "city",
							columnType: 6,
							columnTermList: [],
							areaFun: function(area) {
								let info = {
									level: 2,
									areaCode: area,
								};
								User.getAdressList(info)
									.then((response) => {
										const data = response.data;
										$this.btnList[1].columnList[10].value = "";
										$this.btnList[1].columnList[11].value = "";
										$this.btnList[1].columnList[12].value = "";
										$this.btnList[1].columnList[10].columnTermList = data.data;
									})
									.catch((response) => {});
							},
							placeholder: "请输入地址",
						},
						{
							columnLabel: "区",
							value: "",
							column: "district",
							columnTermList: [],
							columnType: 6,
							areaFun: function(area) {
								let info = {
									level: 3,
									areaCode: area,
								};
								User.getAdressList(info)
									.then((response) => {
										const data = response.data;
										$this.btnList[1].columnList[11].value = "";
										$this.btnList[1].columnList[12].value = "";
										$this.btnList[1].columnList[11].columnTermList = data.data;
									})
									.catch((response) => {});
							},
							placeholder: "请输入地址",
						},
						{
							columnLabel: "街道",
							value: "",
							column: "town",
							columnTermList: [],
							columnType: 6,
							areaFun: function(area) {
								$this.btnList[1].columnList[12].value = "";
							},
							placeholder: "请输入地址",
						},
						{
							columnLabel: "详细地址",
							value: "",
							column: "address",
							columnType: 0,
							placeholder: "请输入地址",
						},
						{
							columnLabel: "邮政编码",
							value: "",
							column: "postcode",
							columnType: 0,
							placeholder: "请输入邮政编码",
						},
						{
							columnLabel: "收款账户",
							value: "",
							column: "collectionAccount",
							columnType: 0,
							placeholder: "请输入收款账户",
						},
						{
							columnLabel: "开户银行",
							value: "",
							column: "openAccountBank",
							columnType: 0,
							placeholder: "请输入开户银行",
						},
						{
							columnLabel: "税号",
							value: "",
							column: "taxNumber",
							columnType: 0,
							placeholder: "请输入税号",
						},
						{
							columnLabel: "安装单位",
							value: "",
							column: "anzhuangUnit",
							columnType: 0,
							placeholder: "请输入安装单位",
						},
						{
							columnLabel: "微信用户限制",
							value: "",
							column: "astrict",
							columnType: 0,
							placeholder: "请输入0~10之间的数字",
						},
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfo).length > 0) {
							tip();
							$this.btnList[1].columnList.forEach(function(item, index) {
								item.value = $this.tableInfo[item.column];
							});
							let info = {
								level: 0,
							};
							User.getAdressList(info)
								.then((response) => {
									const data = response.data;
									$this.btnList[1].columnList[8].columnTermList = data.data;
									$this.btnList[1].columnList[9].columnTermList = "";
									$this.btnList[1].columnList[10].columnTermList = "";
									$this.btnList[1].columnList[11].columnTermList = "";
									$this.btnList[1].columnList[12].columnTermList = "";
								})
								.catch((response) => {});
						} else {
							$this.utils.tipsAlert("请选择数据");
						}
					},
					btnFun: function(tip, info) {
						info.id = $this.tableInfo.id;
						if (info.customerName == "") {
							$this.utils.tipsAlert("请输入客户名称");
							return;
						}
						if (info.abbreviation == "") {
							$this.utils.tipsAlert("请输入所在区域");
							return;
						}
						if (info.customerType === "") {
							$this.utils.tipsAlert("请输入客户类型");
							return;
						}
						if (info.contact == "") {
							$this.utils.tipsAlert("请输入联系人");
							return;
						}
						if (info.province == "") {
							$this.utils.tipsAlert("请输入地址省");
							return;
						}
						if (info.city == "") {
							$this.utils.tipsAlert("请输入地址市");
							return;
						}
						if (info.district == "") {
							$this.utils.tipsAlert("请输入地址区");
							return;
						}
						if (info.town == "") {
							$this.utils.tipsAlert("请输入地址街道");
							return;
						}
						if (info.address == "") {
							$this.utils.tipsAlert("请输入详细地址");
							return;
						}
						if (!(parseInt(info.astrict) >= 0 && parseInt(info.astrict) <= 10)) {
							$this.utils.tipsAlert("0~10之间的数");
							return;
						}
						User.UpdateCustomer(info)
							.then((response) => {
								const data = response.data;
								if (data.code == 1) {
									$this.utils.editAlert();
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize,
									});
									tip();
								} else {
									$this.utils.tipsAlert(data.message);
								}
							})
							.catch((response) => {
								console.log(response);
							});
					},
				});
			}
			if (this.menuList.indexOf("CD_653") != -1) {
				this.btnList.push({
					btnLabel: "删除",
					btnType: 0,
					btnPosition: "left",
					btnFun: function() {
						if (Object.keys($this.tableInfo).length > 0) {
							$this
								.$confirm("是否删除这个客户?", "提示", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning",
								})
								.then(() => {
									var info = [$this.tableInfo.id];
									User.delCustomer(info)
										.then((response) => {
											const data = response.data;
											if (data.code == 1) {
												$this.utils.delAlert();
											} else {
												$this.utils.tipsAlert(data.message);
											}
											$this.search({
												pageNo: $this.pageNo,
												pageSize: $this.pageSize,
											});
										})
										.catch((response) => {
											console.log(response);
										});
								});
						} else {
							$this.utils.tipsAlert("请选择数据");
						}
					},
				});
			}
			if (this.menuList.indexOf("CD_654") != -1) {
				this.btnList = this.btnList.concat([{
						btnLabel: "探测器监视",
						btnType: 0,
						btnPosition: "left",
						btnFun: function() {
							clearTimeout($this.dialogTime);
							if (Object.keys($this.tableInfo).length > 0) {
								//var customerid = $this.tableInfo.id;
				
								$this.geteqMonitor();
								$this.dialogTime = setInterval(() => {
									$this.geteqMonitor();
								}, 3000);
								//alert($this.dialogTime);
								$this.dialogtcqjs = true;
							} else {
								$this.utils.tipsAlert("请选择数据");
							}
						},
					},
					{
						btnLabel: "查询",
						btnType: 3,
						btnPosition: "right",
						btnFun: function() {
							$this.search({
								pageNo: 1,
								pageSize: $this.pageSize,
							});
						},
					}
				]);
			} else {
				this.btnList.push({
					btnLabel: "导出",
					btnType: 2,
					btnPosition: "left",
					filename: "客户信息",
					sheet: [{
						title: "客户信息",
						tHeader: [
							"客户名称",
							"所在区域",
							"客户类型",
							"客户地址",
							"联系人",
							"联系人电话",
						],
						keys: [
							"customerName",
							"abbreviation",
							"customerType",
							"addressDetail",
							"contact",
							"contactPhone",
						],
						table: [],
						sheetName: "用户",
						cellStyle: [{
							cell: "A1",
							font: {
								name: "黑体",
								sz: "18px",
							},
						}],
					}, {
						title: "设备信息",
						tHeader: [
							"客户名称",
							"设备编号",
							"设备名称",
							"设备类型",
							"设备位置",
							"报修时长(天)",
							"生产日期",
							"设备价格(分)",
							"监控燃气种类",
						],
						keys: [
							"customerName",
							"code",
							"name",
							"deviceType",
							"deviceAddress",
							"warranty",
							"productionDate",
							"price",
							"notes",
						],
						table: [],
						sheetName: "设备",
						cellStyle: [{
							cell: "A1",
							font: {
								name: "黑体",
								sz: "18px",
							},
						}],
					}],
				});
				this.btnList = this.btnList.concat([{
						btnLabel: "绑定坐标",
						btnType: 0,
						btnPosition: "left",
						btnFun: function() {
							if (Object.keys($this.tableInfo).length > 0) {
								var info = [$this.tableInfo.id];
								$this.keyword1 = $this.tableInfo.city;
								$this.keyword2 = $this.tableInfo.address;
								$this.dialog = true;
							} else {
								$this.utils.tipsAlert("请选择数据");
							}
						},
					},
					{
						btnLabel: "查看设备",
						btnType: 0,
						btnPosition: "left",
						btnFun: function() {
							if (Object.keys($this.tableInfo).length > 0) {
								var info = $this.tableInfo.customerName;
								var newParam = {
									pageNo: 1,
									pageSize: $this.equipmentpageSize,
									customerName: info
								}
								$this.getDeviceList(newParam);
								$this.dialogequipment = true;
							} else {
								$this.utils.tipsAlert("请选择数据");
							}
						},
					},
					{
						btnLabel: "安装位置",
						btnType: 0,
						btnPosition: "left",
						btnFun: function() {
							if (Object.keys($this.tableInfo).length > 0) {
								$this.dialogaddress = true;
								$this.id = $this.tableInfo.id;
								$this.imgList = [];
								if ($this.tableInfo.img != null && $this.tableInfo.img != '') {
									$this.imgList = $this.tableInfo.img.split(',');
								}
							} else {
								$this.utils.tipsAlert("请选择数据");
							}
						},
					},
					{
						btnLabel: "探测器监视",
						btnType: 0,
						btnPosition: "left",
						btnFun: function() {
							clearTimeout($this.dialogTime);
							if (Object.keys($this.tableInfo).length > 0) {
								//var customerid = $this.tableInfo.id;
				
								$this.geteqMonitor();
								$this.dialogTime = setInterval(() => {
									$this.geteqMonitor();
								}, 3000);
								//alert($this.dialogTime);
								$this.dialogtcqjs = true;
							} else {
								$this.utils.tipsAlert("请选择数据");
							}
						},
					},
					{
						btnLabel: "查询",
						btnType: 3,
						btnPosition: "right",
						btnFun: function() {
							$this.search({
								pageNo: 1,
								pageSize: $this.pageSize,
							});
						},
					}
				]);
			}

		},
		mounted() {
			this.userCustomerList = this.$store.getters.getUserInfo;
			this.getCustomerTypeList();
			this.paddingTop =
				this.$refs.search.clientHeight +
				this.$refs.btnList.clientHeight +
				20 +
				"px";
			this.getWindowHeight();
			window.onresize = () => {
				this.getWindowHeight();
				this.$refs.list.getHeight();
			};
			User.getDeviceType().then((response) => {
				const data = response.data.data;
				let list = [];
				for (var i = 0; i < data.length; i++) {
					list.push({
						id: data[i].dataTypeCode,
						name: data[i].typeName,
					})
				}
				this.equipmenttableList[2].termList = list;
				this.equipmentList = list;
			}).catch((response) => {
				console.log(response)
			})
		},
		beforeDestroy() {

			if (this.dialogTime) {

				clearInterval(this.dialogTime); //关闭
				this.dialogTime = null;
			}
		}
	};
</script>
<style>
	.dialogequipment .el-dialog--center .el-dialog__body {
		padding: 25px 25px 50px;
		overflow-y: scroll;
		height: 600px;
	}

	.dialogequipment .page {
		bottom: 0;
	}

	.dialogequipment .el-table__body-wrapper {
		height: 91% !important;
	}

	.dialogaddress .el-dialog--center .el-dialog__body {
		padding: 25px 25px 50px;
	}

	.dialogaddress .page {
		bottom: 0;
	}

	.dialogaddress .el-table__body-wrapper {
		height: 91% !important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/system/customer.vue